export const singleSystemSettingsUrls = {
  index: '/system-settings/:systemId',
  notificationDetails: ':alarmId',
  menuId: '*',
};
